import { Button, DialogPreset } from '@packages/shared';
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { SimilarProductsActionFragmentFragmentDoc } from '@packages/gql/generated/shopping/SimilarProductsActionFragmentFragmentDoc';
import { PrudsysProductsSimilarRecoSlider as RecoSlider } from '@packages/recommendations';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';

export interface SimilarProductActionProps {
  data: FragmentType<typeof SimilarProductsActionFragmentFragmentDoc>;
  buttonProps?: React.ComponentProps<typeof Button>;
}
export const messages = defineMessages({
  similarItemsButtonText: {
    id: 'SimilarProductsAction.Button.Text',
    defaultMessage: 'ähnliche Artikel',
  },
  similarItemsDialogTitle: {
    id: 'SimilarProductsAction.Dialog.Headline',
    defaultMessage: 'Ähnliche Artikel',
  },
});
/* GraphQL */ `
  fragment SimilarProductsActionFragment on WishlistLineItem {
    extra {
      brand
      category
      orderNumber
    }
  }
`;

export const SimilarProductAction: React.FC<SimilarProductActionProps> = ({
  data,
  buttonProps: { sx: buttonSxOverrides, ...restButtonProps } = {},
}) => {
  const [isSimilarProductsDialogOpen, setIsSimilarProductsDialogOpen] = useState(false);
  const { formatMessage } = useIntl();
  const { extra } = getFragmentData(SimilarProductsActionFragmentFragmentDoc, data);
  if (extra === null) {
    return null;
  }
  return (
    <>
      <Button
        onClick={() => setIsSimilarProductsDialogOpen(true)}
        sx={{
          width: '100%',
          ...buttonSxOverrides,
        }}
        {...restButtonProps}
      >
        {formatMessage(messages.similarItemsButtonText)}
      </Button>
      <DialogPreset
        open={isSimilarProductsDialogOpen}
        onClose={() => setIsSimilarProductsDialogOpen(false)}
        title={formatMessage(messages.similarItemsDialogTitle)}
      >
        <div className="bg-color-grey-light px-3 pb-[5.25rem] pt-3">
          <RecoSlider
            preferTitle
            title=""
            categoryIds={extra?.category ? [extra?.category] : []}
            pageTemplate="wishlist"
            productId={extra?.orderNumber ?? ''}
            brand={extra?.brand ?? ''}
            elementIndex={0}
          />
        </div>
      </DialogPreset>
    </>
  );
};
